import React, { useMemo } from 'react';

import { Badge, Select } from 'antd';

import styled from 'styled-components';

import { getFolderColor, isFolderOfType } from '@libs/NwFolders';

import { useFolders } from '@hooks/API/UseFolders';

import FolderPrivacyIcon from '@components/ContactsFolders/FolderPrivacyIcon';
import FlexContainer from '@components/Gui/FlexContainer';

const StyledSelect = styled(Select)`
    width: 100%;
`;

/**
 * Select delle folder condiviso da filtri e sidebar: stessa riga ovunque (colore, nome,
 * icona privacy) ed elenco sempre letto dalla query. Chi lo usa decide solo il tipo di
 * contatto, il testo del valore vuoto, la selezione multipla e le folder da nascondere.
 */
const FolderSelect = ({
    type = 'model',
    value,
    onChange,
    multiple,
    allowClear,
    placeholder = 'any folder',
    excludedIds,
    ...rest
}) => {
    const { data: folders } = useFolders();

    const typeFolders = useMemo(() => {
        return folders ? folders.filter((folder) => isFolderOfType(folder, type)) : [];
    }, [folders, type]);

    const options = useMemo(() => {
        return typeFolders
            .filter((folder) => !excludedIds || !excludedIds.includes(folder.ID))
            .map((folder) => ({
                value: folder.ID,
                label: (
                    <FlexContainer gap=".5rem">
                        <Badge color={getFolderColor(folder.Color)} />
                        {folder.Name}
                        <FolderPrivacyIcon folder={folder} size="sm" />
                    </FlexContainer>
                ),
            }));
    }, [typeFolders, excludedIds]);

    //le option hanno una label JSX: la ricerca deve guardare il nome della folder
    const filterFolderOption = (input, option) => {
        const folder = typeFolders.find((item) => item.ID === option.value);
        return folder ? folder.Name.toLowerCase().includes(input.toLowerCase()) : false;
    };

    return (
        <StyledSelect
            autoComplete="off"
            showSearch
            filterOption={filterFolderOption}
            mode={multiple ? 'multiple' : undefined}
            allowClear={allowClear}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            options={options}
            {...rest}
        />
    );
};

export default FolderSelect;
